export const ACCOUNT_LEVEL_ACCESSES = {
  ACCOUNT_ADMIN: 'accountAdmin',
  EXECUTIVE: 'executive',
};

export const LICENSE_RESPONSE_STATUSES = {
  CREATED: 201,
  DELETED: 204,
};

export const PROFILE_VARIANTS = {
  PROJECT: 'project',
  ACCOUNT: 'account',
};

export const NO_LICENSE_PLC = 'NO_LICENSE';

export const LICENSE_OPERATION_TYPE = {
  ASSIGN: 'assign',
  UNASSIGN: 'unassign',
};

export const LICENSE_INPUT_TYPES = {
  DROPDOWN: 'dropdown',
  TOGGLE: 'toggle',
};

export const ACCOUNT_OFFERING_TYPES = {
  FIXED_USER: 'fixedUser',
  NONE: 'none',
  TOKEN_FLEX: 'tokenFlex',
};

export const LICENSING_MODELS = {
  RENTAL: 'rental',
  TOKEN_FLEX: 'tflex',
};

export const USER_ACCOUNT_OFFERING_TYPES = {
  INTERNAL: 'internal',
  EXTERNAL: 'external',
  TRIAL: 'trial',
  NONE: 'none',
};

export const USER_SUBSCRIPTION_TYPES = {
  TRIAL: 'trial',
};

export const TRACK_EVENTS_STATUS = {
  SUCCESS: 'success',
  FAILURE: 'failure',
};

export const TRIAL_STATUS = {
  ACTIVE: 'active',
  EXPIRED: 'expired',
};

const BUILD_550 = {
  plc: 'BLD550',
  name: 'Autodesk Build 550',
  trialOfferingExtKey: 'TRIAL-BLDUNLT',
  ranking: 3,
  category: 'autodesk-build',
  categoryName: 'Autodesk Build',
  categoryRanking: 4,
  sheetLimit: 550,
  userAssignable: true,
  // Offerings referencing Autodesk Docs (commercial and token flex)
  includedOfferings: [9, 10, 11],
};

const BUILD_5000 = {
  plc: 'BLD5K',
  name: 'Autodesk Build 5000',
  trialOfferingExtKey: 'TRIAL-BLDUNLT',
  ranking: 2,
  category: 'autodesk-build',
  categoryName: 'Autodesk Build',
  categoryRanking: 4,
  sheetLimit: 5000,
  userAssignable: true,
  includedOfferings: [9, 10, 11],
};

const BUILD_UNLIMITED = {
  plc: 'BLDUNLT',
  name: 'Autodesk Build Unlimited',
  trialOfferingExtKey: 'TRIAL-BLDUNLT',
  ranking: 1,
  category: 'autodesk-build',
  categoryName: 'Autodesk Build',
  categoryRanking: 4,
  sheetLimit: 0,
  userAssignable: true,
  includedOfferings: [9, 10, 11],
};

const COLLABORATE = {
  plc: 'BIMCOLL',
  name: 'Autodesk BIM Collaborate',
  trialOfferingExtKey: 'TRIAL-COLLABORATE_PRO_PLACEHOLDER',
  ranking: 2,
  category: 'autodesk-bim-collaborate',
  categoryName: 'Autodesk BIM Collaborate',
  categoryRanking: 2,
  sheetLimit: 0,
  userAssignable: true,
  includedOfferings: [9, 10, 11],
};

const COLLABORATE_PRO = {
  plc: 'COLLRP',
  name: 'Autodesk BIM Collaborate Pro',
  trialOfferingExtKey: 'TRIAL-COLLABORATE_PRO_PLACEHOLDER',
  ranking: 1,
  category: 'autodesk-bim-collaborate',
  categoryName: 'Autodesk BIM Collaborate',
  categoryRanking: 2,
  sheetLimit: 0,
  userAssignable: true,
  includedOfferings: [9, 10, 11],
};

const TAKEOFF = {
  plc: 'QNTFY',
  name: 'Autodesk Takeoff',
  trialOfferingExtKey: 'TRIAL-QNTFY',
  ranking: 1,
  category: 'autodesk-takeoff',
  categoryName: 'Autodesk Takeoff',
  categoryRanking: 3,
  sheetLimit: 0,
  userAssignable: true,
  includedOfferings: [9, 10, 11],
};

const DOCS = {
  plc: 'BM36DP',
  name: 'Autodesk Docs',
  trialOfferingExtKey: 'TRIAL-BM36DP',
  ranking: 1,
  category: 'autodesk-docs',
  categoryName: 'Autodesk Docs',
  categoryRanking: 1,
  sheetLimit: 0,
  userAssignable: true,
  includedOfferings: [11],
};

export const DOCS_AEC_COLLECTION = {
  plc: 'DOCS',
  name: 'Docs for AEC Collection',
  trialOfferingExtKey: null,
  ranking: 2,
  category: 'autodesk-docs',
  categoryName: 'Autodesk Docs',
  categoryRanking: 1,
  sheetLimit: 0,
  userAssignable: false,
  includedOfferings: [9, 10],
};

export const DOCS_AEC_COLLECTION_OFFERING = {
  ...DOCS_AEC_COLLECTION,
  licensingModel: 'rental',
  offeringExternalKey: 'COM-DOCS',
  type: 'fixedUser',
  quantity: {
    limit: 10,
    assigned: 1,
    available: 9,
  },
};

const AEC_COLLECTION = {
  plc: 'AECCOL',
  name: 'AEC Collection',
  trialOfferingExtKey: 'TRIAL-AECCOL',
  ranking: 1,
  category: 'aec-collection',
  categoryName: 'AEC Collection',
  categoryRanking: 5,
  sheetLimit: 0,
  userAssignable: false,
  includedOfferings: [9, 10],
};

export const ACCOUNT_OFFERINGS_DATA = [
  {
    ...BUILD_550,
    licensingModel: 'rental',
    offeringExternalKey: 'COM-BLD550',
    type: 'none',
    quantity: {
      limit: 0,
      assigned: 0,
      available: 5,
    },
  },
  {
    ...BUILD_5000,
    licensingModel: 'rental',
    offeringExternalKey: 'COM-BLD5K',
    type: 'fixedUser',
    quantity: {
      limit: 5000,
      assigned: 4,
      available: 6,
    },
  },
  {
    ...BUILD_UNLIMITED,
    licensingModel: 'rental',
    offeringExternalKey: 'COM-BLDUNLT',
    type: 'fixedUser',
    quantity: {
      limit: 0,
      assigned: 0,
      available: 9,
    },
  },
  {
    ...BUILD_UNLIMITED,
    licensingModel: 'tflex',
    type: 'none',
    quantity: {
      limit: 0,
      assigned: 0,
      available: 10000,
    },
  },
  {
    ...COLLABORATE,
    licensingModel: 'rental',
    offeringExternalKey: 'COM-BIMCOLL',
    type: 'fixedUser',
    quantity: {
      limit: 0,
      assigned: 5,
      available: 10,
    },
  },
  {
    ...COLLABORATE_PRO,
    licensingModel: 'rental',
    offeringExternalKey: 'SO-4156',
    type: 'fixedUser',
    quantity: {
      limit: 0,
      assigned: 3,
      available: 4,
    },
  },
  {
    ...COLLABORATE_PRO,
    licensingModel: 'tflex',
    type: 'none',
    quantity: {
      limit: 0,
      assigned: 0,
      available: 10000,
    },
  },
  {
    ...TAKEOFF,
    licensingModel: 'rental',
    offeringExternalKey: 'COM-QNTFY',
    type: 'fixedUser',
    quantity: {
      limit: 0,
      assigned: 3,
      available: 3,
    },
  },
  {
    ...TAKEOFF,
    licensingModel: 'tflex',
    type: 'none',
    quantity: {
      limit: 0,
      assigned: 0,
      available: 10000,
    },
  },
  {
    ...DOCS,
    licensingModel: 'rental',
    offeringExternalKey: 'SO-W7yFhwcHmVqr',
    type: 'fixedUser',
    quantity: {
      limit: 10,
      assigned: 1,
      available: 9,
    },
  },
  {
    ...DOCS,
    licensingModel: 'tflex',
    type: 'none',
    quantity: {
      limit: 0,
      assigned: 0,
      available: 10000,
    },
  },
  {
    ...AEC_COLLECTION,
    licensingModel: 'rental',
    offeringExternalKey: 'SO-3051',
    type: 'fixedUser',
    quantity: {
      limit: 10,
      assigned: 0,
      available: 10,
    },
  },
  {
    ...DOCS_AEC_COLLECTION,
    licensingModel: 'rental',
    offeringExternalKey: 'COM-DOCS',
    type: 'fixedUser',
    quantity: {
      limit: 10,
      assigned: 1,
      available: 9,
    },
  },
];

export const ACCOUNT_OFFERINGS_DATA_TOKENFLEX = [
  {
    ...BUILD_550,
    licensingModel: 'rental',
    offeringExternalKey: 'COM-BLD550',
    type: 'fixedUser',
    quantity: {
      limit: 99,
      assigned: 71,
      available: 28,
    },
  },
  {
    ...BUILD_5000,
    licensingModel: 'rental',
    offeringExternalKey: 'COM-BLD5K',
    type: 'fixedUser',
    quantity: {
      limit: 99,
      assigned: 49,
      available: 50,
    },
  },
  {
    ...BUILD_UNLIMITED,
    licensingModel: 'rental',
    offeringExternalKey: 'COM-BLDUNLT',
    type: 'fixedUser',
    quantity: {
      limit: 1099,
      assigned: 1093,
      available: 6,
    },
  },
  {
    ...BUILD_UNLIMITED,
    licensingModel: 'tflex',
    offeringExternalKey: 'TFLEX-BLDUNLT',
    type: 'tokenFlex',
    quantity: {
      limit: 0,
      assigned: 0,
      available: 10000,
    },
  },
  {
    ...COLLABORATE,
    licensingModel: 'rental',
    offeringExternalKey: 'COM-BIMCOLL',
    type: 'fixedUser',
    quantity: {
      limit: 1199,
      assigned: 908,
      available: 291,
    },
  },
  {
    ...COLLABORATE_PRO,
    licensingModel: 'rental',
    offeringExternalKey: 'SO-4156',
    type: 'fixedUser',
    quantity: {
      limit: 999,
      assigned: 115,
      available: 884,
    },
  },
  {
    ...COLLABORATE_PRO,
    licensingModel: 'tflex',
    offeringExternalKey: 'TFLEX-COLLRP',
    type: 'none',
    quantity: {
      limit: 0,
      assigned: 0,
      available: 0,
    },
  },
  {
    ...TAKEOFF,
    licensingModel: 'rental',
    offeringExternalKey: 'COM-QNTFY',
    type: 'fixedUser',
    quantity: {
      limit: 999,
      assigned: 952,
      available: 47,
    },
  },
  {
    ...TAKEOFF,
    licensingModel: 'tflex',
    type: 'tokenFlex',
    quantity: {
      limit: 0,
      assigned: 0,
      available: 10000,
    },
  },
  {
    ...DOCS,
    licensingModel: 'rental',
    offeringExternalKey: 'SO-W7yFhwcHmVqr',
    type: 'fixedUser',
    quantity: {
      limit: 0,
      assigned: 0,
      available: 5,
    },
  },
  {
    ...DOCS,
    licensingModel: 'tflex',
    offeringExternalKey: 'TFLEX-BM36DP',
    type: 'none',
    quantity: {
      limit: 0,
      assigned: 0,
      available: 10000,
    },
  },
  {
    ...AEC_COLLECTION,
    licensingModel: 'rental',
    offeringExternalKey: 'SO-3051',
    type: 'fixedUser',
    quantity: {
      limit: 10,
      assigned: 0,
      available: 10,
    },
  },
  {
    ...DOCS_AEC_COLLECTION,
    licensingModel: 'rental',
    type: 'none',
    quantity: {
      limit: 10,
      assigned: 0,
      available: 10,
    },
  },
];

export const ACCOUNT_OFFERINGS_DOCS_TOKEN_FLEX = [
  {
    ...BUILD_550,
    licensingModel: 'rental',
    offeringExternalKey: 'COM-BLD550',
    type: 'none',
    quantity: {
      limit: 0,
      assigned: 0,
      available: 0,
    },
  },
  {
    ...BUILD_5000,
    licensingModel: 'rental',
    offeringExternalKey: 'COM-BLD5K',
    type: 'none',
    quantity: {
      limit: 0,
      assigned: 0,
      available: 0,
    },
  },
  {
    ...BUILD_UNLIMITED,
    licensingModel: 'rental',
    offeringExternalKey: 'COM-BLDUNLT',
    type: 'fixedUser',
    quantity: {
      limit: 1099,
      assigned: 1093,
      available: 6,
    },
  },
  {
    ...BUILD_UNLIMITED,
    licensingModel: 'tflex',
    offeringExternalKey: 'TFLEX-BLDUNLT',
    type: 'none',
    quantity: {
      limit: 0,
      assigned: 0,
      available: 0,
    },
  },
  {
    ...COLLABORATE,
    licensingModel: 'rental',
    offeringExternalKey: 'COM-BIMCOLL',
    type: 'fixedUser',
    quantity: {
      limit: 1199,
      assigned: 908,
      available: 291,
    },
  },
  {
    ...COLLABORATE_PRO,
    licensingModel: 'rental',
    offeringExternalKey: 'SO-4156',
    type: 'fixedUser',
    quantity: {
      limit: 999,
      assigned: 115,
      available: 884,
    },
  },
  {
    ...COLLABORATE_PRO,
    licensingModel: 'tflex',
    offeringExternalKey: 'TFLEX-COLLRP',
    type: 'tokenFlex',
    quantity: {
      limit: 0,
      assigned: 23,
      available: 10000,
    },
  },
  {
    ...TAKEOFF,
    licensingModel: 'rental',
    offeringExternalKey: 'COM-QNTFY',
    type: 'fixedUser',
    quantity: {
      limit: 999,
      assigned: 952,
      available: 47,
    },
  },
  {
    ...TAKEOFF,
    licensingModel: 'tflex',
    type: 'none',
    quantity: {
      limit: 0,
      assigned: 0,
      available: 0,
    },
  },
  {
    ...DOCS,
    licensingModel: 'rental',
    offeringExternalKey: 'SO-W7yFhwcHmVqr',
    type: 'none',
    quantity: {
      limit: 0,
      assigned: 0,
      available: 0,
    },
  },
  {
    ...DOCS,
    licensingModel: 'tflex',
    offeringExternalKey: 'TFLEX-BM36DP',
    type: 'tokenFlex',
    quantity: {
      limit: 0,
      assigned: 0,
      available: 10000,
    },
  },
  {
    ...AEC_COLLECTION,
    licensingModel: 'rental',
    offeringExternalKey: 'SO-3051',
    type: 'none',
    quantity: {
      limit: 0,
      assigned: 0,
      available: 0,
    },
  },
  {
    ...DOCS_AEC_COLLECTION,
    licensingModel: 'rental',
    type: 'none',
    quantity: {
      limit: 10,
      assigned: 0,
      available: 10,
    },
  },
];

export const ACCOUNT_OFFERINGS_WITH_INCLUDED_PLCS = [
  {
    ...ACCOUNT_OFFERINGS_DATA[0],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[1],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[2],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[3],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[4],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[5],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[6],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[7],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[8],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[9],
    includedPlcs: ['AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[10],
    includedPlcs: ['AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[11],
    includedPlcs: ['BM36DP'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[12],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
];

export const ACCOUNT_OFFERINGS_TOKENFLEX_WITH_INCLUDED_PLCS = [
  {
    ...ACCOUNT_OFFERINGS_DATA_TOKENFLEX[0],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA_TOKENFLEX[1],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA_TOKENFLEX[2],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA_TOKENFLEX[3],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA_TOKENFLEX[4],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA_TOKENFLEX[5],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA_TOKENFLEX[6],
    includedPlcs: ['BM36DP'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA_TOKENFLEX[7],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA_TOKENFLEX[8],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA_TOKENFLEX[9],
    includedPlcs: ['AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA_TOKENFLEX[10],
    includedPlcs: ['AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA_TOKENFLEX[11],
    includedPlcs: ['BM36DP'],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA_TOKENFLEX[12],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
];

export const ACCOUNT_OFFERINGS_NO_TAKEOFF = [
  {
    ...ACCOUNT_OFFERINGS_DATA[0],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[1],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[2],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[3],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[4],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[5],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[6],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[7],
    quantity: {
      limit: 0,
      assigned: 3,
      available: 0,
    },
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[8],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[9],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[10],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[11],
  },
  {
    ...ACCOUNT_OFFERINGS_DATA[12],
  },
];

export const ACCOUNT_OFFERINGS_NO_TAKEOFF_WITH_INCLUDED_PLCS = [
  {
    ...ACCOUNT_OFFERINGS_NO_TAKEOFF[0],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_NO_TAKEOFF[1],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_NO_TAKEOFF[2],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_NO_TAKEOFF[3],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_NO_TAKEOFF[4],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_NO_TAKEOFF[5],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_NO_TAKEOFF[6],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_NO_TAKEOFF[7],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_NO_TAKEOFF[8],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_NO_TAKEOFF[9],
    includedPlcs: ['AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_NO_TAKEOFF[10],
    includedPlcs: ['AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_NO_TAKEOFF[11],
    includedPlcs: ['BM36DP'],
  },
  {
    ...ACCOUNT_OFFERINGS_NO_TAKEOFF[12],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
];

export const ACCOUNT_OFFERINGS_DOCS_TOKEN_FLEX_WITH_INCLUDED_PLCS = [
  {
    ...ACCOUNT_OFFERINGS_DOCS_TOKEN_FLEX[0],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DOCS_TOKEN_FLEX[1],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DOCS_TOKEN_FLEX[2],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DOCS_TOKEN_FLEX[3],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DOCS_TOKEN_FLEX[4],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DOCS_TOKEN_FLEX[5],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DOCS_TOKEN_FLEX[6],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DOCS_TOKEN_FLEX[7],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DOCS_TOKEN_FLEX[8],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DOCS_TOKEN_FLEX[9],
    includedPlcs: ['AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DOCS_TOKEN_FLEX[10],
    includedPlcs: ['AECCOL'],
  },
  {
    ...ACCOUNT_OFFERINGS_DOCS_TOKEN_FLEX[11],
    includedPlcs: ['BM36DP'],
  },
  {
    ...ACCOUNT_OFFERINGS_DOCS_TOKEN_FLEX[12],
    includedPlcs: ['BM36DP', 'AECCOL'],
  },
];
